export const commonConstants = {
    API_URL: 'http://localhost:3000',

    ACTION_GET_LANG: 'ACTION_GET_LANG'
};
